export default __webpack_public_path__ + "static/media/01KanhaPench.69b6f95e.jpg";